// Scroll position and metadata for a node or document.
export class ScrollState {
  left: number = 0; // Horizontal scroll position.
  top: number = 0; // Vertical scroll position.
  watermark: number = 0; // The highest scrolling event id we've seen.
}
